import { FC, useSyncExternalStore } from 'react';
import styles from './styles.module.css';
import classNames from 'classnames';
import loadingImg from '../../../assets/images/loading.svg';
import { fetchTrackStore } from '../../../api/baseQuery';

type LoadingState = 'none' | 'loading';

/**
 * Loading コンポーネント
 *
 * RTK Query での通信状態に合わせてローディング/完了表示をする。
 */
const Loading: FC = () => {
  const state = useLoadingState();

  switch (state) {
    case 'none':
      return null;
    case 'loading':
      return <NowLoading />;
    default:
      throw new Error(`Unknown loading state: ${state satisfies never}`);
  }
};
export default Loading;

function NowLoading() {
  return (
    <div className={styles.backdrop}>
      <div className={classNames(styles.loading, styles.fadeIn)}>
        <div className={styles.iconContainer}>
          <img
            src={loadingImg}
            className={classNames(styles.icon, styles.shake)}
          />
        </div>
        <div className={styles.text}>しばらくお待ち下さい…</div>
      </div>
    </div>
  );
}

function useLoadingState(): LoadingState {
  const count = useSyncExternalStore(
    fetchTrackStore.subscribe,
    fetchTrackStore.count
  );
  return count > 0 ? 'loading' : 'none';
}
